import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { OrangeAccent } from './OrangeAccent';
import { ProgressBar } from './ProgressBar';
interface PillChoicePageProps {
  question: string;
  stepNumber: number;
  subline?: string;
  onYes: () => void;
  onNo: () => void;
}
export function PillChoicePage({
  question,
  stepNumber,
  subline,
  onYes,
  onNo
}: PillChoicePageProps) {
  const [picked, setPicked] = useState<'yes' | 'no' | null>(null);
  const handle = (val: 'yes' | 'no', cb: () => void) => {
    if (picked) return;
    setPicked(val);
    window.setTimeout(cb, 220);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -24
  }} transition={{
    duration: 0.45,
    ease: [0.16, 1, 0.3, 1]
  }} className="relative overflow-hidden w-full max-w-[680px] bg-white border border-line rounded-[16px] p-6 md:p-11 text-left" data-id="element-102">
      <ProgressBar progress={stepNumber / 8 * 100} data-id="element-103" />
      <div className="font-sans font-bold text-[12px] tracking-widest uppercase text-blue-deep mb-5" data-id="element-104">
        Step {stepNumber} of 8
      </div>

      <h1 className="font-display font-extrabold text-[clamp(26px,4vw,38px)] tracking-tight text-ink leading-[1.15]" data-id="element-105">
        {question}
      </h1>
      <OrangeAccent className="mt-3 mb-6" data-id="element-106" />

      {subline && <p className="font-sans text-[16px] text-ink-soft mb-6 leading-relaxed" data-id="element-107">
          {subline}
        </p>}

      <div className="flex flex-col gap-3 mt-2" data-id="element-108">
        <button type="button" onClick={() => handle('yes', onYes)} disabled={picked !== null && picked !== 'yes'} className={['w-full font-display font-bold text-[18px] py-[18px] rounded-[12px] transition-colors duration-200', 'bg-orange text-white hover:bg-orange-deep', picked === 'yes' ? 'bg-orange-deep' : ''].join(' ')} data-id="element-109">
          Yes
        </button>
        <button type="button" onClick={() => handle('no', onNo)} disabled={picked !== null && picked !== 'no'} className={['w-full font-display font-bold text-[18px] py-[18px] rounded-[12px] transition-colors duration-200', 'bg-transparent border-[1.5px] border-line-strong text-ink hover:border-orange', picked === 'no' ? 'border-orange' : ''].join(' ')} data-id="element-110">
          No
        </button>
      </div>
    </motion.div>;
}